import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AddAccountsDialogService } from '../../ApplicationViews/Services/add-accounts-dialog.service';
import { ApplicationViewsService } from '../../ApplicationViews/Services/application-views.services';
import { catchError, map, tap } from 'rxjs/operators';
import { Subscription, pipe } from 'rxjs';
import { ApplicationViewsResource } from 'src/app/client-api.service';
import { forEach } from 'ramda';
import { NotificationsService } from 'src/app/shared/tcc-ui/notifications';

@Component({
  selector: 'app-add-accounts-dialog',
  templateUrl: './add-accounts-dialog.component.html',
  styleUrls: ['./add-accounts-dialog.component.scss']
})
export class AddAccountsDialogComponent implements OnInit, OnDestroy {

  allApplicationViews: ApplicationViewsResource[] | undefined;
  applicationViews$ = this.appViewsServices.applicationViews$;
  currentView = '';
  currentApplicationViews: ApplicationViewsResource[] | undefined;
  isOpen: boolean = false;
  subs: Subscription[] | undefined;
  distinctAccounts: ApplicationViewsResource[] | undefined;
  selectedAccounts: ApplicationViewsResource[] | undefined;

  constructor(private addAccountsDialogService: AddAccountsDialogService,
    private appViewsServices: ApplicationViewsService,
    private notifSvc: NotificationsService) {

    this.subs = [];

    this.subs?.push(this.addAccountsDialogService.dialogState$.subscribe((state => {
      this.isOpen = state.isOpen;
      if (state.data) {
        this.selectedAccounts = [];
        this.currentApplicationViews = state.data.currentViews;;
        this.currentView = state.data.viewName;
        this.appViewsServices.setApplicationViews();
      }
    })));
  }

  ngOnInit(): void {
    this.selectedAccounts = [];
    this.subs!.push(this.appViewsServices.getDisctinctAccountCodes()
      .pipe(
        map((a) => {          
          // remove those accounts that are already in the current AccountView
          this.distinctAccounts = a.filter((a) => !this.currentApplicationViews?.some(c => c.accountCode === a.accountCode && c.parentAccountCode === a.parentAccountCode))
          return this.distinctAccounts;
        }),
      )
      .subscribe());
  }

  ngOnDestroy(): void {
    this.subs!.forEach(s => s.unsubscribe());
  }

  onAccountSelected(accountCode: string, parentAccountCode: string) {
    const row = document.getElementById(accountCode + '_' + parentAccountCode);

    // find the account and add it to the lias of accounts to add
    this.selectedAccounts = [];
    let selectedAccount = this.distinctAccounts?.find(a => a.accountCode === accountCode);
    if (selectedAccount !== null || selectedAccount !== undefined) { // make sure there is an accout to add
      selectedAccount!.isChecked = true;
      this.selectedAccounts?.push(selectedAccount!);

      // is a parent record
      if (selectedAccount?.parentAccountCode === null || selectedAccount?.parentAccountCode === undefined) { // it's a parent so get all under the parent

        this.addChildren(selectedAccount!.accountCode);

      }
      else {// not a parent starting record so get the parent then repeat
        while (selectedAccount?.parentAccountCode !== null && selectedAccount?.parentAccountCode !== undefined) {
          selectedAccount = this.distinctAccounts?.find(a => a.accountCode === selectedAccount!.parentAccountCode);
          if (selectedAccount !== null && selectedAccount !== undefined) { // make sure theire is an accout to add
            selectedAccount!.isChecked = true;
            this.selectedAccounts?.push(selectedAccount);
          }
        }
      }
    }
  }

  onSelectedAccountSelected(accountCode: string, parentAccountCode: string) {
    const account = this.selectedAccounts?.find(a => a.accountCode === accountCode && a.parentAccountCode === parentAccountCode);
    if (account) {
      if (account.isChecked) {
        this.addParent(account.accountCode);
      }
      else {
        this.removeChildrenFromSelected(accountCode);
      }
    }
  }

  addParent(accountCode: string) {
    const account = this.selectedAccounts?.find(a => a.accountCode === accountCode);
    if (account) {
      account.isChecked = true;
      this.addParent(account.parentAccountCode);
    }
  }

  removeChildrenFromSelected(accountCode: string) {
    const account = this.selectedAccounts?.filter(a => a.parentAccountCode === accountCode);

    account?.forEach(a => {
      if (a) {
        a.isChecked = false; // we don't want to save this because it's parent is being removed
        this.removeChildrenFromSelected(a.accountCode);
      }
    });
  }

  addChildren(parentAccountCode: string) {
    const children = this.distinctAccounts?.filter(a => a.parentAccountCode === parentAccountCode);

    children?.forEach(c => {
      const existing = this.selectedAccounts?.find(a => a.accountCode === c.accountCode);
      if (!existing) {
        c.isChecked = true;
        this.selectedAccounts?.push(c);
      }
      this.addChildren(c.accountCode);
    })
  }

  close() {
    this.addAccountsDialogService.close();
  }

  save() {
    
    const applicationViews = [] as ApplicationViewsResource[];

    for (let account of this.selectedAccounts!) {
      if (account.isChecked) {
        const exists = this.currentApplicationViews?.find(a => a.key === this.currentView + ':' + account.accountCode)
        if (!exists) {
          const applicationView = {} as ApplicationViewsResource;
          applicationView.key = this.currentView + ':' + account.accountCode;
          applicationView.view = this.currentView;
          applicationView.accountCode = account.accountCode;
          applicationView.parentAccountCode = account.parentAccountCode;
          applicationView.name = account.name;
          applicationView.calculationExpression = account.calculationExpression;
          applicationView.displayAccountCode = account.displayAccountCode;
          applicationView.isNegated = account.isNegated;
          applicationView.sortIndex = account.sortIndex;
          applicationView.isReadOnly = account.isReadOnly;
          applicationView.isIgnoredInTotals = account.isIgnoredInTotals;
          applicationView.customValidation = account.customValidation;
          applicationView.isHidden = account.isHidden;
          applicationView.deletedOn = account.deletedOn;
          applicationView.deletedByUserId = account.deletedByUserId;
          applicationView.isChecked = account.isChecked;

          applicationViews.push(applicationView);
        }
      }
    }

    this.appViewsServices.putApplicationViews(applicationViews).subscribe(() => {
      this.appViewsServices.setApplicationViews();
      this.appViewsServices.setViewInfos();
      this.addAccountsDialogService.confirm();
    })
  }
}

